export const classWhitelist = ['blockContent', 'document-content'];
export const rxClassWhitelist = (new RegExp(classWhitelist.qSelect((x) => `\\b${x}\\b`).join('|')));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/highlight/settings.tsx